import { promos } from "$lib/models/promos";

let today = new Date(Date.now());
let utcNowDate = today.getUTCDate();
let setUtcDateNow = today.setUTCDate(utcNowDate);

let validDeals = promos.filter((promo) => {
   let initDate = new Date(Date.UTC(promo?.publish_date[0], promo?.publish_date[1], promo?.publish_date[2]));
   let utcPromoDate = initDate.getUTCDate();
   let setUTCpromoInitDate = initDate.setUTCDate(utcPromoDate);
   let endDate = new Date(Date.UTC(promo?.end_date[0], promo?.end_date[1], promo?.end_date[2]));
   let utcPromoEndDate = endDate.getUTCDate();
   let setUTCpromoEndDate = endDate.setUTCDate(utcPromoEndDate);
   if (setUTCpromoInitDate <= setUtcDateNow && setUTCpromoEndDate >= setUtcDateNow) {
      return promo;
   }
});
let saleLinks = [{
   "name": 'SALE',
   "link": '/sale'
}];
validDeals.map(item => {
   saleLinks.push(
      {
         link: item.link,
         name: item.name.toUpperCase(),
      }
   )
});

export const menu = [
   {
      "main": "SALE",
      "submenu": saleLinks,
   },
   {
      "main": "SHOP",
      "submenu": [
         {
            "name": "COLORS",
            "link": "/colors",
         },
         {
            "name": "COLLECTIONS",
            "link": "/colors/collections",
         },
         {
            "name": "COLOR BUNDLES",
            "link": "/colors/bundles",
         }, {
            "name": "SOFT GEL EXTENSIONS",
            "link": "/soft-gel/short-round",
         },
         {
            "name": "GEL NAIL POLISH",
            "link": "/gelish",
         },
         {
            "name": "CAT EYE",
            "link": "/gelish/cat-eye",
         },
         {
            "name": "FLASH GLAM GELS",
            "link": "/gelish/flash-gels",
         },
         {
            "name": "NAIL POLISH",
            "link": "/morgan-taylor",
         },
         {
            "name": "MORGAN TAYLOR NATURALS",
            "link": "/morgan-taylor/naturals",
         },
         {
            "name": "DIP POWDER",
            "link": "/enhancements/xpress-dip-n-brush",
         },
         {
            "name": "HARD GELS",
            "link": "/enhancements/hard-gels",
         },
         {
            "name": "ACRYLIC",
            "link": "/enhancements/prohesion",
         },
         {
            "name": "POLYGEL",
            "link": "/enhancements/polygel",
         },
         {
            "name": "LED LAMPS",
            "link": "/nail-lamps-tools/led-lamps",
         },
         {
            "name": "E-FILES",
            "link": "/nail-lamps-tools/e-files",
         },
         {
            "name": "NAIL DUST COLLECTOR",
            "link": "/nail-lamps-tools/vortex",
         },
         {
            "name": "BRUSHES AND TOOLS",
            "link": "/nail-lamps-tools/brushes-and-tools",
         },
         {
            "name": "NAIL STRENGTHENERS",
            "link": "/nail-care",
         },
         {
            "name": "MANI AND PEDI",
            "link": "/nail-care/bare-luxury",
         },
         {
            "name": "NAIL ART",
            "link": "/nail-arts",
         },
         {
            "name": "SOLID CREAM GEL POLISH",
            "link": "/nail-arts/cream-gel",
         },
      ]
   },
   {
      "main": "NEW ARRIVALS",
      "submenu": [
         {
            "name": "NEW ARRIVALS",
            "link": "/new",
         },
         {
            "name": "NEW COLLECTION",
            "link": "/collections/spring-2025",
         },
      ]
   },
   {
      "main": "BEST SELLERS",
      "submenu": [
         {
            "name": "BEST SELLERS",
            "link": "/best-sellers",
         }
      ]
   },
   {
      "main": "LEARN MORE",
      "submenu": [
         {
            "name": "BLOG",
            "link": "/nail-style-blog",
         },
         {
            "name": "VIRTUAL SALON",
            "link": "/virtual-salon",
         },
         {
            "name": "VIDEOS",
            "link": "/videos",
         },
      ]
   }
];


//    "content": [
//       {
//          "link": "/sale",
//           "Sale",
//          "childrens": [
//             {
//                "link": "/sale/all-gelish-gel-polish",
//                "text": "ALL GELISH GEL POLISH ONLY $15.99"
//             },
//             {
//                "link": "/sale/nail-art-gels",
//                "text": "30% OFF ALL GELISH ART GELS"
//             },
//             {
//                "link": "/sale/e-files-bits",
//                "text": "30% OFF ALL E-FILES & BITS"
//             },
//             {
//                "link": "/sale/dip-powders",
//                "text": "25% OFF ALL DIP POWDERS"
//             },
//             {
//                "link": "/sale/soft-gel",
//                "text": "BUT 2 GET 2 FREE ALL SOFT GEL 550ct TIPS"
//             },
//             {
//                "link": "/sale/morgan-taylor",
//                "text": "MORGAN TAYLOR 3 FOR $10"
//             },
//             {
//                "link": "/sale/bare-luxury",
//                "text": "40% OFF WHEN BUY 12 BARELUXURY 4 PACKS"
//             }
//          ]
//       },
//       {
//          "link": "/colors",
//          "main": "Colors",
//          "childrens": [
//             {
//                "link": "/colors/collections",
//                "text": "COLLECTIONS"
//             },
//             {
//                "link": "/colors/bundles",
//                "text": "COLOR BUNDLES"
//             },
//             {
//                "link": "/colors/gelish",
//                "text": "SEARCH ALL"
//             },
//             {
//                "link": "/colors/gelish/purple",
//                "text": "PURPLE"
//             },
//             {
//                "link": "/colors/gelish/pink",
//                "text": "PINK"
//             },
//             {
//                "link": "/colors/gelish/red",
//                "text": "RED"
//             },
//             {
//                "link": "/colors/gelish/orange-coral",
//                "text": "ORANGE & CORAL"
//             },
//             {
//                "link": "/colors/gelish/green-blue",
//                "text": "GREEN & BLUE"
//             },
//             {
//                "link": "/colors/gelish/neutral",
//                "text": "NEUTRAL"
//             },
//             {
//                "link": "/colors/gelish/glitter",
//                "text": "GLITTER"
//             },
//             {
//                "link": "/colors/gelish/metallic",
//                "text": "METALLIC"
//             }
//          ]
//       },
//       {
//          "link": "/soft-gel/short-round",
//          "main": "SOFT GEL EXTENSIONS",
//          "childrens": [
//             {
//                "link": "/soft-gel/short-round",
//                "text": "TIPS"
//             },
//             {
//                "link": "/soft-gel/short-round#neutral-tips",
//                "text": "NEUTRAL TIPS"
//             },
//             {
//                "link": "/soft-gel/short-round#essentials",
//                "text": "ESSENTIALS"
//             },
//             {
//                "link": "/soft-gel/short-round#lights",
//                "text": "LIGHTS"
//             },
//             {
//                "link": "/soft-gel/short-round",
//                "text": "SHORT ROUND"
//             },
//             {
//                "link": "/soft-gel/medium-round",
//                "text": "MEDIUM ROUND"
//             },
//             {
//                "link": "/soft-gel/medium-coffin",
//                "text": "MEDIUM COFFIN"
//             },
//             {
//                "link": "/soft-gel/long-coffin",
//                "text": "LONG COFFIN"
//             },
//             {
//                "link": "/soft-gel/medium-square",
//                "text": "MEDIUM SQUARE"
//             },
//             {
//                "link": "/soft-gel/stiletto-medium",
//                "text": "MEDIUM STILETTO"
//             }
//          ]
//       },
//       {
//          "link": "/gelish",
//          "main": "Gel Nail Polish",
//          "childrens": [
//             {
//                "link": "/colors/gelish",
//                "text": "GEL COLORS"
//             },
//             {
//                "link": "/gelish/cat-eye",
//                "text": "CAT EYE"
//             },
//             {
//                "link": "/gelish/flash-gels",
//                "text": "FLASH GLAM GELS"
//             },
//             {
//                "link": "/gelish#base-top",
//                "text": "BASE AND TOP COATS"
//             },
//             {
//                "link": "/gelish#essentials",
//                "text": "ESSENTIALS"
//             }
//          ],
//          "seeMore": "/gelish"
//       },
//       {
//          "link": "/morgan-taylor",
//          "main": "NAIL POLISH",
//          "childrens": [
//             {
//                "link": "/colors/morgan-taylor",
//                "text": "MORGAN TAYLOR COLORS"
//             },
//             {
//                "link": "/morgan-taylor/naturals",
//                "text": "MORGAN TAYLOR NATURALS"
//             },
//             {
//                "link": "/morgan-taylor#peel-off-glitter",
//                "text": "PEEL-OFF GLITTER"
//             },
//             {
//                "link": "/morgan-taylor#base-top",
//                "text": "BASE AND TOP COATS"
//             },
//             {
//                "link": "/morgan-taylor#essentials",
//                "text": "ESSENTIALS"
//             }
//          ],
//             "seeMore": "/morgan-taylor"
//       },
//       {
//          "link": "/enhancements",
//          "main": "ENHANCEMENTS",
//          "childrens": [
//             {
//                "link": "/enhancements/xpress-dip-n-brush",
//                "text": "DIP POWDER"
//             },
//             {
//                "link": "/products/gelish-brush-on-builder-0-5-fl-oz-sc/1148021",
//                "text": "BRUSH-ON BUILDER"
//             },
//             {
//                "link": "/enhancements/hard-gels",
//                "text": "HARD GELS"
//             },
//             {
//                "link": "/enhancements/prohesion",
//                "text": "ACRYLIC"
//             },
//             {
//                "link": "/enhancements/polygel",
//                "text": "POLYGEL"
//             }
//          ]
//       },
//       {
//          "link": "/nail-lamps-tools",
//          "main": "NAIL LAMPS AND TOOLS",
//          "childrens": [
//             {
//                "link": "/nail-lamps-tools/led-lamps",
//                "text": "LED LAMPS"
//             },
//             {
//                "link": "/nail-lamps-tools/e-files",
//                "text": "E-FILES"
//             },
//             {
//                "link": "/nail-lamps-tools/vortex",
//                "text": "NAIL DUST COLLECTOR"
//             },
//             {
//                "link": "/nail-lamps-tools/brushes-and-tools",
//                "text": "BRUSHES AND TOOLS"
//             }
//          ],
//             "seeMore": "/nail-lamps-tools"
//       },
//       {
//          "link": "/nail-care",
//          "main": "NAIL CARE",
//          "childrens": [
//             {
//                "link": "/nail-care/bare-luxury",
//                "text": "MANI AND PEDI"
//             },
//             {
//                "link": "/nail-care",
//                "text": "NAIL STRENGTHENERS"
//             }
//          ]
//       },
//       {
//          "link": "/nail-arts",
//          "main": "Nail Art",
//          "childrens": [
//             {
//                "link": "/nail-arts/cream-gel",
//                "text": "SOLID CREAM <br/> GEL POLISH"
//             },
//             {
//                "link": "/nail-arts#blooming-gel",
//                "text": "BLOOMING GEL"
//             },
//             {
//                "link": "/nail-arts#chrome-stix",
//                "text": "CHROME STIX"
//             },
//             {
//                "link": "/nail-arts#art-forms",
//                "text": "ART FORM GELS"
//             },
//             {
//                "link": "/nail-arts#foil-gel",
//                "text": "NO LIGHT FOIL GEL"
//             }
//          ]
//       }
//    ]
// }
// {
//     summary: "New",
//    "link": "/new",
//    "cont"ent: [
//       {
//          "link": "/new",
//          "main": "NEW ARRIVALS",
//       },
//       {
//          "link": "/colors/collections/fall-2024",
//          "main": "NEW COLLECTION",
//       },
//    ],
// },
// {
//     summary: "Best Sellers",
//    "link": "/best-sellers""}",
//    {
//     summary: "Blog",
//       "link": "/nail-style-blog""}",
//       {
//     summary: "Learn More",
//          "link": "/learn-more",
//          "cont"ent: [
//             {
//                "link": "/virtual-salon",
//                "main": "VIRTUAL SALON",
//             },
//             {
//                "link": "/videos",
//                "main": "VIDEOS",
//             },
//          ]
//       },